<template>
    <div class="layout-sidebar" @click="onMenuClick">
        <router-link to="/" class="logo">
            <img id="app-logo" class="logo-image" src="assets/irinox/logo/menu-small.svg" alt="Irinox FreshCloud" />
            <img id="app-name" class="app-name" src="assets/irinox/logo/menu-text.svg" alt="Irinox FreshCloud" />
        </router-link>

        <div class="layout-menu-container">
          <div :class="['irinox-menu',{'irinox-menu-user':role==='USER'}]">
            <div class="irinox-menu-top">
              <AppSubmenu :items="model" :layoutMode="layoutMode" :parentMenuItemActive="true" :menuActive="active" :mobileMenuActive="mobileMenuActive" :root="true" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick" :bottom="false"/>
            </div>
            <div class="irinox-menu-bottom">
              <AppSubmenu :items="model" :layoutMode="layoutMode" :parentMenuItemActive="true" :menuActive="active" :mobileMenuActive="mobileMenuActive" :root="true" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick" :bottom="true"/>
              <div class="layout-menu">
                <ul>
                  <li>
                    <a class="p-ripple" @click="onMenuButtonClick" v-ripple>
                        <i :class="['layout-menuitem-icon', 'icon-menu close']" style="background-image: url('assets/irinox/icons/arrow_close.svg')"></i>
                        <span class="layout-menuitem-text">{{ $t('menu.close_menu') }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu";
import { mapGetters } from 'vuex';
export default {
    name: "AppMenu",
    emits: ["menu-click", "menuitem-click", "root-menuitem-click", "menu-button-click"],
    props: {
        model: Array,
        layoutMode: String,
        active: Boolean,
        mobileMenuActive: Boolean
    },
    computed: {
      ...mapGetters({
        role: 'userdata/role',
      }),
    },
    methods: {
        onMenuButtonClick(event) {
            this.$emit("menu-button-click", event);
        },
        onMenuClick(event) {
            this.$emit("menu-click", event);
        },
        onMenuItemClick(event) {
            this.$emit("menuitem-click", event);
        },
		onRootMenuItemClick(event) {
			this.$emit("root-menuitem-click", event);
		}
    },
    components: { AppSubmenu },
};
</script>

<style lang="scss">

  .irinox-menu {
    position: relative;
    height: calc(100vh - 140px);
    min-height: 510px;
    min-width: 42px;
  }
  .irinox-menu.irinox-menu-user {
    min-height: 750px;
  }
  .irinox-menu-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .icon-menu {
    background-repeat: no-repeat;
    background-position: center center;
    width: 42px;
    height: 40px;
    display: block;
  }
  
  .icon-menu.haccp {
    background-size: 34px 34px;
  }
  .icon-menu.analytics {
    background-size: 32px 32px;
  }

  .menu-openclose {
    display: flex;
    padding-left: 2px;
    padding-top: 5px;
    cursor: pointer;
  }
  .menu-openclose i {
    width: 40px;
    height: 40px;
    font-size: 1.5rem;
    margin-right: 1rem;
    text-align: center;
  }

</style>